export type CalendarEvent = {
    id: string;
    eventDate: string;
    eventDateString: string;
    eventTimeString: string;
    name?: string;
    location?: string;
    thumbnail?: string;
    thumbnailAltText?: string;
    synopsis?: string;
    buyTicketCtaUrl?: string;
    buyTicketCtaText?: string;
    viewDetailCtaUrl?: string;
    viewDetailCtaText?: string;
    categories?: string[];
    soldOutText?: string;
    isSoldOut?: boolean;
    availability?: number;
    availabilityIndicatorText?: string;
    availabilityClass?: string;
    hideAvailability?: boolean;
}

export type Day = {
    date: string;
    events: CalendarEvent[]
}

export type Month = {
    month: string;
    days: Day[];
    anyEvents?: boolean;
}

export type DateRange = {
    startDate: string;
    endDate: string;
}

// Filter types
// This is the single source of truth for all filter types. If you are adding/removing filter types, start here, then edit all instances that use the enum.
export enum FilterType {
    LOCATION = "location",
    CATEGORIES = "categories",
    NAME = "name"
}

export type FilterText = Record<FilterType, string>;

export type FilterState = Record<FilterType, FilterAppliedState>;

export type RecordWithOptionalKeys<K extends keyof any, T> = {
    [P in K]?: T;
}

export type CombinedFilterData = RecordWithOptionalKeys<FilterType, FilterResponse[] | null>;

export type FilterResponse = {
    value: string;
    /*
     * misspelled in the API
     */
    firstOccurance: string;
    text: string;
}

export type FilterAppliedState = {
    value: string[],
    /*
     * misspelled in the API
     */
    firstOccurance?: string
}

export type DatePosition = {
    dateString: string;
    offsetTop: number;
    height: number;
}